import { useEffect, useState } from "react";
import { useLocation, Navigate } from "react-router-dom";
import { BRAND_PAGES, BRAND_ALIASES } from "../data/brandPages";
import { MODULES } from "../components/site/BrandModules";
import { CTABand } from "../components/site/CTABand";
import { applySeo } from "../lib/seo";

const API = process.env.REACT_APP_BACKEND_URL;

const fixImg = (spec) => {
  // uploaded images are stored as /api/uploads/... -> prefix backend URL
  const walk = (v) => {
    if (typeof v === "string") return v.startsWith("/api/uploads/") ? `${API}${v}` : v;
    if (Array.isArray(v)) return v.map(walk);
    if (v && typeof v === "object") return Object.fromEntries(Object.entries(v).map(([k, x]) => [k, walk(x)]));
    return v;
  };
  return walk(spec);
};

export default function BrandProductPage() {
  const { pathname } = useLocation();
  const raw = pathname.endsWith("/") ? pathname : `${pathname}/`;
  const path = BRAND_ALIASES[raw] || raw;
  const [page, setPage] = useState(null);
  const [missing, setMissing] = useState(false);

  useEffect(() => {
    let alive = true;
    setPage(null);
    setMissing(false);
    fetch(`${API}/api/pages/spec?path=${encodeURIComponent(path)}`)
      .then((r) => (r.ok ? r.json() : Promise.reject(r.status)))
      .then((spec) => { if (alive) setPage(fixImg(spec)); })
      .catch((status) => {
        if (!alive) return;
        if (BRAND_PAGES[path]) setPage(BRAND_PAGES[path]);
        else if (status === 404) setMissing(true);
      });
    window.scrollTo(0, 0);
    return () => { alive = false; };
  }, [path]);

  useEffect(() => {
    if (page) {
      const aliases = Object.entries(BRAND_ALIASES).filter(([, v]) => v === path).map(([k]) => k);
      applySeo({ paths: [path, ...aliases], fallbackTitle: page.seoTitle });
    }
  }, [page, path]);

  if (missing) return <Navigate to="/" replace />;
  if (!page) return <main className="min-h-[60vh]" data-testid="brand-page-loading" />;

  return (
    <main data-testid={`brand-page${path.replaceAll("/", "-")}`}>
      {page.modules.map((m, i) => {
        const Cmp = MODULES[m.type];
        if (!Cmp) return null;
        return <Cmp key={`${m.type}-${i}`} m={m} theme={page.theme} path={path} />;
      })}
      <CTABand product={page.cta} />
    </main>
  );
}
